import { ClientProposition, PAGES, PropositionsTabProps } from "@dune/types";
import { DataTable } from "@dune/ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetClientPropositions } from "../../../api/queries/clients.queries";
import { clientPropositionsColumns } from "./propositionTab/clientPropositionsColumns";

const PropositionsTab: React.FC<PropositionsTabProps> = ({ client }) => {
	const navigate = useNavigate();

	const {
		data: propositionsData,
		isLoading,
		error,
	} = useGetClientPropositions(
		client.id.toString(),
		client.clientType || undefined,
	);

	const columns = clientPropositionsColumns();

	const handleRowClick = (proposition: ClientProposition) => {
		navigate(PAGES.PROPOSALS.show.withParams(proposition.id.toString()));
	};

	if (error) {
		return (
			<div className="p-6">
				<div className="text-red-600">
					Erreur lors du chargement des propositions: {error.message}
				</div>
			</div>
		);
	}

	return (
		<div>
			<div className="flex items-center justify-between mb-6">
				<div className="text-2xl font-semibold text-gray-900">Propositions</div>
			</div>

			<DataTable
				data={propositionsData?.data || []}
				columns={columns}
				isLoading={isLoading}
				onRowClick={handleRowClick}
				noResultsText="Aucune proposition"
			/>
		</div>
	);
};

export default PropositionsTab;
